import Head from 'next/head';
import { HeadTitleContent } from '../../../../commons/Constants';
import ReliefFactor from '../../../../components/mui5/products/ReliefFactor';
import PainRelief from '../../../../components/mui5/products/PainRelief';
import { productImages } from '../../../images';
import { config, productsKeyConstants } from '../../../../config';
import initVWOSdk from '../../../../commons/helpers/Analytics/vwo/vwoHelper';
import { v4 as uuidv4 } from 'uuid';
import cookie from 'cookie';
import { useState } from 'react';

export default function QuickStart({ userId, variationName }) {
  const [vwoInstance, setVwoInstacne] = useState(null);

  const showVarientA = variationName == 'variant-a';
  const path_url = config.SiteURL.slice(0, -1);
  return (
    <>
      <Head>
        <meta
          property="og:title"
          content={HeadTitleContent['quickstart'].title}
          key="ogtitle"
        />
        <meta
          property="og:description"
          content={HeadTitleContent['quickstart'].description}
          key="ogdescription"
        />
        <meta
          property="og:url"
          content={path_url + HeadTitleContent['quickstart'].path}
          key="ogurl"
        />
        <meta
          property="og:image"
          content={`${
            path_url + productImages[productsKeyConstants.RF_RELIEF_FACTOR_QS]
          }`}
          key="ogimage"
        />
      </Head>
      {showVarientA ? (
        <PainRelief userId={userId} vwoClientInstance={vwoInstance} />
      ) : (
        <ReliefFactor
          userId={userId}
          vwoClientInstance={vwoInstance}
          variationName={variationName}
        />
      )}
    </>
  );
}
export async function getServerSideProps(context) {
  let userId = null;
  let variationName = 'control-a';
  let userAgent = '';
  let userIP = '';
  // try {
  //   userAgent = context?.req?.headers['user-agent'] || '';
  //   userIP =
  //     context?.req?.headers['x-real-ip'] ||
  //     context?.req?.headers['x-forwarded-for'] ||
  //     context?.req?.connection?.remoteAddress ||
  //     '';

  //   if (context.req.cookies.vwo_uid) {
  //     userId = context.req.cookies.vwo_uid;
  //   } else {
  //     userId = uuidv4();
  //     const setCookie = cookie.serialize('vwo_uid', userId, {
  //       httpOnly: false,
  //       maxAge: 86400,
  //       secure: false,
  //       path: '/',
  //     });
  //     context.res.setHeader('Set-Cookie', setCookie);
  //   }
  //   const vwoClientInstance = await initVWOSdk(config.vwo.sdkKey);
  //   const userData = {
  //     campaignKey: config.vwo.campaignKey,
  //     userId: userId,
  //   };
  //   let options = {
  //     userStorageData: vwoClientInstance.userStorageService,
  //     userAgent: userAgent,
  //     userIpAddress: userIP,
  //   };
  //   const setUserStorageService =
  //     vwoClientInstance.userStorageService.set(userData);
  //   variationName = vwoClientInstance.activate(
  //     config.vwo.campaignKey,
  //     userId,
  //     options
  //   );
  // } catch (err) {
  //   console.log(err);
  // }

  return {
    props: {
      userId,
      userAgent,
      userIP,
      variationName: variationName,
      extraMeta: {
        title: HeadTitleContent['quickstart'].title,
        description: HeadTitleContent['quickstart'].description,
        schemaData: 'quickStart',
      },
    },
  };
}
